<template>
  <div class="sidebar-ptz-control-container" v-show="visible">
    <div style="display: grid; grid-template-columns: 1fr; gap: 10px;">
      <div style="display: grid; grid-template-columns: 180px auto;">
        <div class="ptz-direction-control">
          <div class="direction-container">
            <div class="direction-btn direction-top" @mousedown="ptzCamera('up')" @mouseup="ptzCamera('stop')">
              <i class="el-icon-arrow-up"></i>
            </div>
            <div class="direction-btn direction-left" @mousedown="ptzCamera('left')" @mouseup="ptzCamera('stop')">
              <i class="el-icon-arrow-left"></i>
            </div>
            <div class="direction-btn direction-bottom" @mousedown="ptzCamera('down')" @mouseup="ptzCamera('stop')">
              <i class="el-icon-arrow-down"></i>
            </div>
            <div class="direction-btn direction-right" @mousedown="ptzCamera('right')" @mouseup="ptzCamera('stop')">
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="direction-center">
              <i class="fa fa-pause-circle"></i>
            </div>
          </div>
          <div class="control-speed" style="margin-top: 10px; width: 100%;">
            <el-slider v-model="controSpeed" :max="100"></el-slider>
          </div>
        </div>
        <div class="ptz-functions">
          <div class="ptz-btn-box">
            <div @mousedown="ptzCamera('zoomin')" @mouseup="ptzCamera('stop')" title="变倍+">
              <i class="el-icon-zoom-in control-zoom-btn" style="font-size: 1.2rem;"></i>
            </div>
            <div @mousedown="ptzCamera('zoomout')" @mouseup="ptzCamera('stop')" title="变倍-">
              <i class="el-icon-zoom-out control-zoom-btn" style="font-size: 1.2rem;"></i>
            </div>
          </div>
          <div class="ptz-btn-box">
            <div @mousedown="focusCamera('near')" @mouseup="focusCamera('stop')" title="聚焦+">
              <i class="iconfont icon-bianjiao-fangda control-zoom-btn" style="font-size: 1.2rem;"></i>
            </div>
            <div @mousedown="focusCamera('far')" @mouseup="focusCamera('stop')" title="聚焦-">
              <i class="iconfont icon-bianjiao-suoxiao control-zoom-btn" style="font-size: 1.2rem;"></i>
            </div>
          </div>
          <div class="ptz-btn-box">
            <div @mousedown="irisCamera('in')" @mouseup="irisCamera('stop')" title="光圈+">
              <i class="iconfont icon-guangquan control-zoom-btn" style="font-size: 1.2rem;"></i>
            </div>
            <div @mousedown="irisCamera('out')" @mouseup="irisCamera('stop')" title="光圈-">
              <i class="iconfont icon-guangquan- control-zoom-btn" style="font-size: 1.2rem;"></i>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align: left">
        <el-select v-model="ptzMethod" style="width: 100%" size="mini" placeholder="请选择云台功能">
          <el-option label="预置点" value="preset"></el-option>
          <el-option label="巡航组" value="cruise"></el-option>
          <el-option label="自动扫描" value="scan"></el-option>
          <el-option label="雨刷" value="wiper"></el-option>
          <el-option label="辅助开关" value="switch"></el-option>
        </el-select>

        <ptzPreset :channelDeviceId="channelId" :deviceId="deviceId" v-if="ptzMethod === 'preset'" style="margin-top: 0.5rem"></ptzPreset>
        <ptzCruising :channelDeviceId="channelId" :deviceId="deviceId" v-if="ptzMethod === 'cruise'" style="margin-top: 0.5rem"></ptzCruising>
        <ptzScan :channelDeviceId="channelId" :deviceId="deviceId" v-if="ptzMethod === 'scan'" style="margin-top: 0.5rem"></ptzScan>
        <ptzWiper :channelDeviceId="channelId" :deviceId="deviceId" v-if="ptzMethod === 'wiper'" style="margin-top: 0.5rem"></ptzWiper>
        <ptzSwitch :channelDeviceId="channelId" :deviceId="deviceId" v-if="ptzMethod === 'switch'" style="margin-top: 0.5rem"></ptzSwitch>
      </div>
    </div>
  </div>
</template>

<script>
import PtzPreset from "./ptzPreset.vue";
import PtzCruising from "./ptzCruising.vue";
import ptzScan from "./ptzScan.vue";
import ptzWiper from "./ptzWiper.vue";
import ptzSwitch from "./ptzSwitch.vue";

export default {
  name: "sidebarPtzControl",
  components: {
    PtzPreset, PtzCruising, ptzScan, ptzWiper, ptzSwitch
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    deviceId: {
      type: String,
      default: ""
    },
    channelId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      controSpeed: 50,
      ptzMethod: "preset"
    };
  },
  methods: {
    ptzCamera: function (command) {
      console.log('云台控制：' + command);
      this.$axios({
        method: 'get',
        url: '/api/front-end/ptz/' + this.deviceId + '/' + this.channelId + '?command=' + command + '&horizonSpeed=' + parseInt(this.controSpeed * 255/100) + '&verticalSpeed=' + parseInt(this.controSpeed * 255/100) + '&zoomSpeed=' + parseInt(this.controSpeed * 16/100)
      }).then(function (res) {
      });
    },
    irisCamera: function (command) {
      this.$axios({
        method: 'get',
        url: '/api/front-end/fi/iris/' + this.deviceId + '/' + this.channelId + '?command=' + command + '&speed=' + parseInt(this.controSpeed * 255/100)
      }).then(function (res) {
      });
    },
    focusCamera: function (command) {
      this.$axios({
        method: 'get',
        url: '/api/front-end/fi/focus/' + this.deviceId + '/' + this.channelId + '?command=' + command + '&speed=' + parseInt(this.controSpeed * 255/100)
      }).then(function (res) {
      });
    }
  }
};
</script>

<style>
.sidebar-ptz-control-container {
  width: 100%;
  background-color: #f5f7fa;
  color: #333;
  padding: 0px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
}

.ptz-direction-control {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.direction-container {
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  width: 100px;
  height: 100px;
  margin: 10px auto 0 auto;
}

.direction-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.2s;
}

.direction-btn i {
  background-color: #1f2d3d;
  border-radius: 50%;
  width: 1.7rem;
  height: 1.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.direction-btn i:hover {
  background-color: #409EFF;
  transform: scale(1.1);
}

.direction-center {
  grid-column: 2;
  grid-row: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.direction-center i {
  color: #1f2d3d;
  font-size: 1.5rem;
  transition: all 0.2s;
}

.direction-center i:hover {
  color: #409EFF;
  transform: scale(1.1);
}

.direction-top {
  grid-column: 2;
  grid-row: 1;
  justify-self: center;
  align-self: center;
}

.direction-left {
  grid-column: 1;
  grid-row: 2;
  justify-self: center;
  align-self: center;
}

.direction-right {
  grid-column: 3;
  grid-row: 2;
  justify-self: center;
  align-self: center;
}

.direction-bottom {
  grid-column: 2;
  grid-row: 3;
  justify-self: center;
  align-self: center;
}

.ptz-functions {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.ptz-btn-box {
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 0 0.5rem;
  height: 1.8rem;
  line-height: 1.8rem;
}

.control-zoom-btn {
  cursor: pointer;
}

.control-zoom-btn:hover {
  color: #409EFF;
}
</style>


// WEBPACK FOOTER //
// src/components/common/sidebarPtzControl.vue